import type { BreakpointsOptions } from '@mui/material';

export const PRIMARY_FONT_FAMILY = 'Radikal, -apple-system, sans-serif';
export const SECONDARY_FONT_FAMILY = 'Trade Gothic LT Std, -apple-system, sans-serif';
export const PRIMARY_FONT_FAMILY_HOS = 'T1 Korium, -apple-system, sans-serif';
export const SECONDARY_FONT_FAMILY_HOS = 'Helvetica Neue, -apple-system, sans-serif';
export const TERTIARY_FONT_FAMILY_HOS = 'Apercu Mono, -apple-system, sans-serif';

export const breakpoints = {
    values: {
        xs: 0,
        sm: 393,
        md: 768,
        lg: 1024,
        xl: 1920,
    },
} as const satisfies BreakpointsOptions;

export const palette = {
    mode: 'light',

    primary: {
        light: '#F11061',
        main: '#E6204F',
        dark: '#E80053',
        contrastText: '#FFFFFF',
    },

    secondary: {
        light: '#CEFFFF',
        main: '#CEFFFF',
        dark: '#497D95',
    },

    text: {
        primary: '#101010',
        secondary: '#979797',
        disabled: '#D8D8D8',
        placeholder: '#CDCDCD',
    },

    divider: '#ECEDEE',

    success: {
        light: 'rgba(76, 182, 105, 0.1)',
        main: '#4CB669',
        dark: '#4CB669',
        contrastText: '#FFFFFF',
    },

    error: {
        light: 'rgba(226, 10, 87, 0.05)',
        main: '#E20A57',
        dark: '#E20A57',
    },

    warning: {
        light: 'rgba(255, 215, 30, 0.1)',
        main: '#FFD71E',
        dark: '#FFD71E',
    },

    background: {
        default: '#FFFFFF',
        paper: '#F5F5F5',
    },

    common: {
        black: '#000000',
        white: '#FFFFFF',
    },

    grey: {
        100: '#F3F1F1',
        500: '#707070',
        600: 'rgba(112, 112, 112, 0.50)',
        900: '#282828',
    },

    button: {
        disabled: 'rgba(226, 10, 87, 0.40)',
    },

    customBlue: '#1096D4',
} as const;

export const hosPalette = {
    mode: 'light',

    primary: {
        light: '#F26852',
        main: '#F26852',
        dark: '#F26852',
        contrastText: '#FFFFFF',
    },

    secondary: {
        light: '#FFFFFF',
        main: '#FFFFFF',
        dark: '#132227',
    },

    text: {
        primary: '#132227',
        secondary: '#979797',
        disabled: '#CACBC8',
        placeholder: '#B7B7B7',
    },

    divider: '#F26852',

    success: {
        light: '#4CB669',
        main: '#4CB669',
        dark: '#4CB669',
        contrastText: '#FFFFFF',
    },

    error: {
        light: 'rgba(255, 0, 0, 0.04)',
        main: '#FF0000',
        dark: '#FF0000',
    },

    warning: {
        light: 'rgba(255, 215, 30, 0.1)',
        main: '#FFD71E',
        dark: '#FFD71E',
    },

    background: {
        default: '#F2F0EB',
        paper: '#132227',
    },

    common: {
        black: '#132227',
        white: '#FFFFFF',
    },

    grey: {
        100: '#B7B7B7',
        500: '#707070',
        600: 'rgba(112, 112, 112, 0.50)',
        900: '#282828',
    },

    button: {
        disabled: 'rgba(242, 104, 82, 0.20)',
    },

    customBlue: '#1096D4',
} as const;
